<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="text-container">
        <div class="title-area">
            <h1 class="page-title">
                {{ screentexts[38]?screentexts[38].element_text:'Set Survey Information' }}:
                <span :class="`${anon ? 'g-anon-lg' : '' }`">
                  {{ group_name }}
                </span>
                <!-- <PopupBubble
                  v-if="screentexts[38] && screentexts[38].element_bubbletext != '' && screentexts[38].element_bubbletext !== null"
                  element_id="set-information"
                  screenelement_id="38"
                  :screen_id="screen_id"
                  :bubbletext="screentexts[38]?screentexts[38].element_bubbletext:''"
                /> -->
            </h1>
        </div>
        <div class="pb-4">
          {{ screentexts[39]?screentexts[39].element_text:"Now it's time to set up your new survey. Please note that your “survey type” settings cannot be changed once your survey has been sent. Neither which optional questions to include or exclude in your survey. Remaining settings can be changed until you run your report." }}
        </div>
        <div class="pb-4">
          <span class="text-danger">*</span> Mandatory
        </div>
        <b-form-group
          class="px-0 mx-0"
        >
          <template slot="label">
            {{ screentexts[40]?screentexts[40].element_text:'Give your survey a name.' }}
          </template>
          <b-form-input
            required
            :class="`${anon ? 'g-anon' : '' }`"
            v-model="survey_name"
            :placeholder="screentexts[41]?screentexts[41].element_text:'Survey name.'"
          />
        </b-form-group>

        <b-form-group
          class="px-0 mx-0"
          :description="screentexts[42]?screentexts[42].element_bubbletext:'Please select the type of survey to create..'"
        >
          <template slot="label">
            {{ screentexts[42]?screentexts[42].element_text:'Please select the type of survey to create' }}
          </template>
          <b-form-radio-group
            required
            v-model="survey_type_id"
            @change="language_options_get(survey_type_id);normvalues_countries_get();spotify_invoice_reference_get();"
          >
            <b-form-radio
              v-for="option in surveytype_options"
              :key="option.value"
              :value="option.value"
              class="d-block"
            >
              {{ option.text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="profile.spotify === '1' && survey_type_id === '2'">
          <b-form-checkbox
            id="spotify"
            v-model="spotify"
            name="spotify"
            value="1"
            unchecked-value="0"
            @change="language_options_get(survey_type_id);normvalues_countries_get();spotify_invoice_reference_get();"
          >
            This is a Spotify survey
          </b-form-checkbox>
        </b-form-group>
        <b-form-group
          class="px-0 mx-0"
          :description="screentexts[43]?screentexts[43].element_bubbletext:'Which language would you like to use for this survey?.'"
        >
          <template slot="label">
            {{ screentexts[43]?screentexts[43].element_text:'Survey language.' }}
          </template>
          <b-form-select
            required
            v-model="survey_language_id"
            :options="language_options"
          />
        </b-form-group>

        <b-form-group
          v-if="survey_type_id != 3"
          class="px-0 py-0"
          :description="screentexts[44]?screentexts[44].element_bubbletext:'Which set of norms do you want to use for this survey? You can change this later..'"
        >
          <template slot="label">
            {{ screentexts[44]?screentexts[44].element_text:'Norm data.' }}
          </template>
          <b-form-radio-group
            required
            v-model="survey_normvalues_id"
          >
            <b-form-radio
              v-for="option in norm_values_options"
              :key="option.value"
              :value="option.value"
              class="d-block"
            >
              {{ option.text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <div v-if="survey_type_id==1">
          <b-form-group
            label="Additional questions"
          >
          <p class="text-md mb-2">
            {{ screentexts[177]?screentexts[177].element_bubbletext:'Optional questions to be included in the survey. Not used for the GDQ calculations.' }}
            <i class="fa-solid fa-circle-question tooltip-question" v-b-tooltip="screentexts[178] ? screentexts[178].element_text : 'These questions are optional. If checked they will be included in the report. They will not be used for the GDQ calculations.'"></i>
          </p>

            <b-form-checkbox-group
              :options="excludablequestions"
              v-model="excludedquestions"
              @change="logit"
              stacked
            >
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div class="buttons-navigation">
          <b-link
            to="/create/group/survey"
            class="float-left"
          >
            <b-button variant="secondary">
              &lt; {{ screentexts[48]?screentexts[48].element_text:'Back' }}
            </b-button>
          </b-link>
          <b-link
            v-if="survey_name != '' && survey_language_id != null && survey_normvalues_id != null && has_online==1"
            to="/create/group/survey/emailsettings"
            class="float-right"
          >
            <b-button variant="primary">
              {{ screentexts[49]?screentexts[49].element_text:'Next' }} &gt;
            </b-button>
          </b-link>
          <b-link
            v-if="survey_name != '' && survey_language_id != null && survey_normvalues_id != null && has_online==0"
            to="/create/group/survey/dates"
            class="float-right"
          >
            <b-button
              variant="primary"
              :disabled="loading"
            >
              <span v-show="!loading">Next ></span>
              <b-spinner
                v-show="loading"
                small
              />
            </b-button>
          </b-link>
          <b-button
            v-if="survey_name == '' || survey_language_id == null || survey_normvalues_id == null"
            disabled
            variant="primary"
            class="disabled float-right"
          >
            <span v-show="!loading">Next ></span>
            <b-spinner
              v-show="loading"
              small
            />
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
// import PopupBubble from './PopupBubble.vue'

export default {
  name: 'CreateGroupSurveyDetails',
  components: {
    Navbar,
    Breadcrumb
    // PopupBubble,
  },
  data () {
    return {
      profile: this.$store.state.profile,
      group_name: this.$store.state.currentgroup.group_name,
      suvey_id: 0,
      survey_name: this.$store.state.currentsurvey.survey_name,
      survey_language_id: this.$store.state.currentsurvey.survey_language_id,
      survey_normvalues_id: this.$store.state.currentsurvey.survey_normvalues_id,
      survey_type_id: this.$store.state.currentsurvey.survey_type_id,
      survey_invoice_reference: this.$store.state.currentsurvey.survey_invoice_reference,
      spotify: this.$store.state.currentsurvey.spotify,
      surveytype_options: [],
      excludablequestions: [],
      excludedquestions: [],
      has_online: 0,
      has_paper: 0,
      screen_id: 5,
      screentexts: [],
      language_options: [],
      norm_values_options: [],
      loading: false
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    survey_id: {
      get () {
        return this.$store.state.currentsurvey_id
      },
      set () {
        return true
      }
    }
  },
  watch: {
    survey_id: function () {
      this.survey_name = this.$store.state.currentsurvey.survey_name
      this.survey_language_id = this.$store.state.currentsurvey.survey_language_id
      this.survey_normvalues_id = this.$store.state.currentsurvey.survey_normvalues_id
      this.survey_type_id = this.$store.state.currentsurvey.survey_type_id
      this.survey_invoice_reference = this.$store.state.currentsurvey.survey_invoice_reference
      var members = this.$store.state.currentsurveymembers
      for (var i = 0; i < members.length; i++) {
        if (members[i].groupsurveymember_formoption_id == 1 || members[i].groupsurveymember_formoption_id == 3) { this.has_online = 1 }
        if (members[i].groupsurveymember_formoption_id == 2) { this.has_paper = 1 }
      }
      this.excludablequestions_get()
    },
    survey_language_id: async function () {
      await this.groupsurvey_save()
        .then(() => {
          this.excludablequestions_get() // Refetch excludable questions when language changes
        })
    },
    survey_type_id: async function () {
      if (this.survey_type_id == 2) {
        this.survey_normvalues_id = 999
      }
    }
  },
  async created () {
    this.loading = true
    await this.profile_get()
    await this.screentexts_get()
    await this.group_get()
    await this.survey_get()
    await this.normvalues_countries_get()
    await this.language_options_get(this.survey_type_id)
    await this.spotify_invoice_reference_get()
    this.loading = false
  },
  mounted () {
    this.survey_get()
    this.excludablequestions_get()
  },
  async beforeRouteLeave (to, from, next) {
    // ---------------------------------------------------------------------------
    // We are going forward - save, I wonder should I change "create" to "save" ?
    // ---------------------------------------------------------------------------
    if (to.name == 'creategroupsurveyemailsettings' || to.name == 'creategroupsurveydates') {
      await this.groupsurvey_save()
    }
    next()
  },
  methods: {
    logit () {
      // NOOP
    },
    spotify_invoice_reference_get () {
      if (this.profile.spotify == 1) {
        if (this.spotify == 1 && this.survey_type_id == 2) {
          this.$store.dispatch('syspref_get', { name: 'spotify_invoice_reference' })
            .then((resp) => {
              this.survey_invoice_reference = resp.data.value
            })
        } else {
          this.survey_invoice_reference = ''
        }
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    language_options_get (survey_type_id) {
      var filter = {}
      if (this.spotify === '1' && survey_type_id == 2) {
        this.language_options = []
        this.language_options.push({
          value: 38,
          text: 'English'
        })
        this.survey_language_id = 38
        return true
      }
      switch (survey_type_id) {
        case '1':
          filter['language_enabled'] = {
            operator: '=',
            value: '1'
          }
          break
        case '2':
          filter['language_enabled_gdq_short'] = {
            operator: '=',
            value: '1'
          }
          break
        case '3':
          filter['language_enabled_osc'] = {
            operator: '=',
            value: '1'
          }
          break
        default:
          filter['language_enabled'] = {
            operator: '=',
            value: '1'
          }
      }
      this.$store.dispatch('records_readall', { table_name: 'g_languages', filter: filter, orderby: 'language_name' })
        .then((resp) => {
          this.language_options = []
          for (var i = 0; i < resp.data.result.length; i++) {
            this.language_options.push({
              value: resp.data.result[i].id,
              text: resp.data.result[i].language_name
            })
            if (resp.data.result[i].id == 38) {
              this.survey_language_id = resp.data.result[i].id
            }
          }
          if (this.survey.survey_language_id !== 0) {
            this.survey_language_id = this.survey.survey_language_id
            return true
          }
          if (this.$store.state.currentsurvey.survey_language_id !== 0) {
            this.survey_language_id = this.$store.state.currentsurvey.survey_language_id
            return true
          }
          if (this.$store.state.currentgroup) {
            this.survey_language_id = this.$store.state.currentgroup.group_language_id
            return true
          }
        })
      return true
    },
    profile_get: async function () {
      await this.$store.dispatch('profile_fetch')
        .then((resp) => {
          this.profile = resp.data
          this.$store.dispatch('surveytypes_fetch')
            .then((resp) => {
              var items = resp.data.result
              var options = []
              for (var i = 0; i < items.length; i++) {
                var option = {
                  value: items[i].id,
                  text: items[i].surveytype_name
                }
                options.push(option)
              }
              this.surveytype_options = options
            })
        })
      if (this.profile.spotify === '1') { this.spotify = '1' }
    },
    screentexts_get: async function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    // ---------------------------------------------------
    // Update the survey already created in previous step
    // ---------------------------------------------------
    async groupsurvey_save () {
      const excludedquestions = this.excludablequestions.filter(
        q => !this.excludedquestions.includes(q.generalquestion_id)
      ).map(q => q.generalquestion_id)
      await this.$store.dispatch('excludedquestions_save', { survey_id: this.survey_id, questions: excludedquestions })

      var survey = {
        id: this.$store.state.currentsurvey_id,
        survey_name: this.survey_name,
        survey_language_id: this.survey_language_id,
        survey_normvalues_id: this.survey_normvalues_id,
        survey_type_id: this.survey_type_id,
        survey_invoice_reference: this.survey_invoice_reference,
        survey_start_date: this.$store.state.currentsurvey.survey_start_date,
        survey_end_date: this.$store.state.currentsurvey.survey_end_date,
        survey_reminder_date: this.$store.state.currentsurvey.survey_reminder_date,
        survey_reminder_email: this.$store.state.currentsurvey.survey_reminder_email,
        survey_reminder_mobile: this.$store.state.currentsurvey.survey_reminder_mobile,
        survey_reminder: this.$store.state.currentsurvey.survey_reminder,
        spotify: this.profile.spotify === '1' && this.survey_type_id === '2' && this.spotify === '1' ? '1' : '0'
      }
      await this.$store.dispatch('groupsurvey_save', { survey: survey })
        .then(async (resp) => {
          this.survey_id = resp.data.id
          const data = {
            survey_id: this.survey_id,
            survey_language_id: survey.survey_language_id,
            survey_type_id: survey.survey_type_id
          }
          await this.$store.dispatch('groupsurvey_changelanguage', data)
            .then(async (resp) => {
              this.survey_invitation_text = resp.data.survey_invitation_text
              this.survey_invitation_subject = resp.data.survey_invitation_subject
              this.survey_get()
              await this.$store.dispatch('groupsurvey_setcurrent', { survey_id: this.survey_id })
              return true
            })
        })
    },
    group_get: async function () {
      await this.$store.dispatch('group_fetch')
        .then(() => {
          this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
        })
    },
    survey_get: async function () {
      await this.$store.dispatch('groupsurvey_fetch', { id: this.$store.state.currentsurvey_id })
        .then((resp) => {
          this.survey = resp.data
          this.$store.dispatch('groupsurveymembers_fetch', { survey_id: resp.data.id })
            .then((resp2) => {
              var members = resp2.data.result
              for (var i = 0; i < members.length; i++) {
                if ((members[i].groupsurveymember_formoption_id == 1 || members[i].groupsurveymember_formoption_id == 3) && members[i].included_in_survey == 1) { this.has_online = 1 }
                if (members[i].groupsurveymember_formoption_id == 2 && members[i].included_in_survey == 1) { this.has_paper = 1 }
              }
            })
        })
        .then(() => {
          this.$store.commit('survey_set', this.survey)
        })
    },
    async excludablequestions_get () {
      this.loading = true
      this.excludablequestions = []
      this.excludedquestions = []
      await this.$store.dispatch('excludedquestions_fetch', { survey_id: this.survey_id })
        .then((resp) => {
          this.excludablequestions = resp.data.questions
          for (var i = 0; i < resp.data.questions.length; i++) {
            this.excludablequestions[i].generalquestion_text = this.excludablequestions[i].generalquestion_text.replace(/:/g, '')
            this.excludablequestions[i].value = this.excludablequestions[i].generalquestion_id
            this.excludablequestions[i].text = this.excludablequestions[i].generalquestion_text
            this.excludablequestions[i].exluded = 1
            if (resp.data.questions[i].excluded == 0) {
              if (!this.excludedquestions.includes(resp.data.questions[i].generalquestion_id)) {
                this.excludedquestions.push(resp.data.questions[i].generalquestion_id)
              }
            } else {
              const index = this.excludedquestions.indexOf(resp.data.questions[i].generalquestion_id)
              if (index !== -1) {
                this.excludedquestions.splice(index)
              }
            }
          }
        })
      this.loading = false
    },
    normvalues_countries_get: async function () {
      this.norm_values_options = []
      if (this.spotify === '1' && this.survey_type_id == 2) {
        this.norm_values_options.push({
          value: 999,
          text: 'Global'
        })
        this.survey_normvalues_id = 999
        return true
      }

      let options = []
      await this.$store.dispatch('normvalues_countries_fetch')
        .then((resp) => {
          const countries = resp.data
          for (let i = 0; i < countries.length; i++) {
            if (countries[i].country_id == 999 || this.survey_type_id == 1) {
              var option = {
                value: countries[i].country_id,
                text: countries[i].country_name
              }
              options.push(option)
            }
          }
          this.norm_values_options = options
          if (this.survey.survey_language_id !== 0) {
            this.survey_language_id = this.survey.survey_language_id
            return true
          }
          if (this.$store.state.currentsurvey.survey_normvalues_id !== 0) {
            this.survey_normvalues_id = this.$store.state.currentsurvey.survey_normvalues_id
            return true
          }
          if (this.$store.state.currentgroup) {
            this.survey_normvalues_id = this.$store.state.currentgroup.survey_normvalues_id
            return true
          }
        })
    }
  }
}
</script>
<style scoped>
.gdq-strike {
  text-decoration: line-through;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
